import React from 'react';
import { makeStyles } from '@mui/styles'
import { useForm, Controller } from 'react-hook-form';
import { Button, Grid } from '@mui/material';
import { convertirLetraMayus } from '../../../helpers/convertirLetraMayus';
import { CustomInputArea } from '../../CustomInputArea';
import { CustomInputText } from '../../CustomInputText';

export const SettingsSurvey = (props) => {

    const { data, action } = props;
    const classes = useStyles();
    const { handleSubmit, control, formState: { errors } } = useForm();

    return (
        <div className={ classes.container }>
            <form className={ classes.form } onSubmit={ handleSubmit((args) => action({ _id: data?._id, ...args })) }>
                <Grid container spacing={2}>
                    <Grid item xs={ 12 } sm={ 12 } md={ 6 } lg={ 6 } xl={ 6 }>
                        <Controller 
                            name='msj_tratamiento_datos_encuestas'
                            control={ control }
                            defaultValue={ convertirLetraMayus(data.msj_tratamiento_datos_encuestas) }
                            render={({ field: { onChange, value } }) => (
                                <CustomInputArea
                                    label="Tratamiento de datos personales"
                                    placeholder=""
                                    error={ errors?.msj_tratamiento_datos_encuestas } 
                                    onChange={ onChange }
                                    value={ value }
                                    rows={ 6 }
                                />
                            )}
                            
                            rules={{ 
                                required: 'El campo es requerido.',
                                pattern: {
                                    value: /^[^\s][a-zA-Z0-9 ].+[^ ]$/gm,
                                    message: "El texto ingresado no es válido.",
                                }
                            }}
                        />
                    </Grid>

                    <Grid item xs={ 12 } sm={ 12 } md={ 6 } lg={ 6 } xl={ 6 }>
                        <Controller 
                            name='msj_despedida_encuestas'
                            control={ control }
                            defaultValue={ convertirLetraMayus(data?.msj_despedida_encuestas) || '' }
                            render={({ field: { onChange, value } }) => (
                                <CustomInputArea
                                    label="Mensaje de despedida"
                                    placeholder=""
                                    error={ errors?.msj_despedida_encuestas } 
                                    onChange={ onChange }
                                    value={ value }
                                    rows={ 6 }
                                />
                            )}
                                
                            rules={{ 
                                required: 'El campo es requerido.',
                                pattern: {
                                    value: /^[^\s][a-zA-Z0-9 ].+[^ ]$/gm,
                                    message: "El texto ingresado no es válido.",
                                }
                            }}
                        />
                    </Grid>

                    <Grid item xs={ 4 } sm={ 4 } md={ 2 } lg={ 2 } xl={ 2 }>
                        <Controller 
                            name='meta_satisfaccion'
                            control={ control }
                            defaultValue={ data?.meta_satisfaccion?.$numberDecimal || '' }
                            render={({ field: { onChange, value } }) => (
                                <CustomInputText
                                    label="Meta satisfacción"
                                    placeholder="00.00"
                                    error={ errors?.meta_satisfaccion }
                                    onChange={ onChange }
                                    value={ value }
                                />
                            )}
                            
                            rules={{
                                required: 'El campo es requerido.',
                                pattern: {
                                    value: /^[0-9]{1,3}[.][0-9]{1,2}$/,
                                    message: "El valor no es válido.",
                                }
                            }}
                        />
                    </Grid>

                    <Grid item xs={ 4 } sm={ 4 } md={ 2 } lg={ 2 } xl={ 2 }>
                        <Controller 
                            name='meta_recomendacion'
                            control={ control }
                            defaultValue={ data?.meta_recomendacion?.$numberDecimal || '' }
                            render={ ({ field: { onChange, value } }) => (
                                <CustomInputText
                                    label="Meta recomendación"
                                    placeholder="00.00"
                                    error={ errors?.meta_recomendacion }
                                    onChange={ onChange }
                                    value={ value }
                                />
                            )}
                            
                            rules={{
                                required: 'El campo es requerido.',
                                pattern: {
                                    value: /^[0-9]{1,3}[.][0-9]{1,2}$/,
                                    message: "El valor no es válido.",
                                }
                            }}
                        />
                    </Grid>

                    <Grid item xs={ 4 } sm={ 4 } md={ 2 } lg={ 2 } xl={ 2 }>
                        <Controller 
                            name='peso_satisfaccion'
                            control={ control }
                            defaultValue={ data?.peso_satisfaccion?.join(',') || '' }
                            render={ ({ field: { onChange, value } }) => (
                                <CustomInputText
                                    label="Peso satisfacción"
                                    placeholder="1,2,3,4,5"
                                    error={ errors?.peso_satisfaccion }
                                    onChange={ onChange }
                                    value={ value }
                                />
                            )}
                            
                            rules={{
                                required: 'El campo es requerido.',
                                pattern: {
                                    value: /^[0-9]{1,3}[,| ,]+[0-9]{1,3}[,| ,]+[0-9]{1,3}[,| ,]+[0-9]{1,3}[,| ,]+[0-9]{1,3}$/,
                                    message: "El valor no es válido.",
                                }
                            }}
                        />
                    </Grid>

                    <Grid item xs={ 4 } sm={ 4 } md={ 2 } lg={ 2 } xl={ 2 }>
                        <Controller 
                            name='correo'
                            control={ control }
                            defaultValue={ data?.correo || '' }
                            render={ ({ field: { onChange, value } }) => (
                                <CustomInputText
                                    label="Correo notificación"
                                    placeholder="abc@mail.com"
                                    error={ errors?.correo }
                                    onChange={ onChange }
                                    value={ value }
                                />
                            )}
                            
                            rules={{
                                required: 'El campo es requerido.'
                            }}
                        />
                    </Grid>
                </Grid>  
            
                <div
                    style={{
                        position: 'fixed',
                        bottom: 0,
                        padding: '20px 20px',
                        left: 0,
                        width: window.innerWidth,
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center'
                    }}
                >            
                    <Button
                        type="submit"
                        variant="outlined"
                        size="small"
                        className={classes.successBtn}
                    >
                        Guardar
                    </Button>
                </div>
            </form>
        </div>
    )
}

const useStyles = makeStyles({
    container: {
        width: '100%',
        height: window.innerHeight,
        background: '#fff',
        borderRadius: 4,
        marginTop: 10,
        position: 'relative'
    },
    form: {
        padding: 20,
    },
    successBtn: {
        background: '#00365F !important',
        color: '#fff !important',
        fontWeight: 'bold !important',
        '&:hover': {
            color: '#00365F !important',
            background: '#fff !important',
            borderColor: '#00365F !important'
        }
    }
});